import { NavItem } from '../../vertical/sidebar/nav-item/nav-item';

export const navItems: NavItem[] = [
  {
    navCap: 'Home',
  },
  // {
  //   displayName: 'Dashboards',
  //   iconName: 'home',
  //   route: 'dashboards/dashboard1'
  // },
  {
  displayName: 'Dashboard',
  iconName: 'layout-dashboard',
  route: '/dashboard',
  },
  {
  displayName: 'Model Creation',
  iconName: 'shirt',
  route: '/products',
  },
  {
    displayName: 'Labdips',
    iconName: 'color-swatch',
    route: '/labdips',
  },
  {
  displayName: 'Bulks',
  iconName: 'file-text',
  route: '/bulks',
  },
  {
  displayName: 'Sourcing',
  iconName: 'file-analytics',
  route: '/sourcing',
  },
  {
  displayName: 'Sampling',
  iconName: 'file-analytics',
  route: '/protos',
  },
  {
  displayName: 'Trims',
  iconName: 'tags',
  route: '/trims',
  },
  {
  displayName: 'Print & Embroidery',
  iconName: 'photo',
  route: '/print-embroidery',
  },
  {
    id: 1002,
    displayName: 'Notification hub',
    iconName: 'bell-ringing',
    route: '/notifications/hub',
  },
  {
    displayName: 'Settings',
    iconName: 'settings',
    route: '/settings',
  },
];
